export const WhiteLogo = () => (
	<>
		{/* biome-ignore lint/a11y/noSvgWithoutTitle: <explanation> */}
		<svg
			width="44"
			height="30"
			viewBox="0 0 44 30"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M16.8064 21.1964H8.18427V29.6667H16.8064V21.1964Z"
				fill="white"
			/>
			<path
				d="M20.6111 0.333374L8.18429 21.1964V8.80366H0V0.333374H20.6111Z"
				fill="white"
			/>
			<path
				d="M19.739 29.6667V18.2364H13.4581L24.123 0.333374V11.7644H30.4039L19.739 29.6667Z"
				fill="white"
			/>
			<path
				d="M35.6771 0.333374H27.0549V8.80366H35.6771V0.333374Z"
				fill="white"
			/>
			<path
				d="M43.8644 21.1965V29.6668H23.2488L28.2968 21.1965L35.6757 8.80371V21.1965H43.8644Z"
				fill="white"
			/>
			<path
				opacity="0.48"
				d="M35.6758 19.2352V21.1965H28.2969L35.6758 19.2352Z"
				fill="url(#paint0_linear_1686_2837)"
			/>
			<path
				opacity="0.48"
				d="M8.18427 10.7657V8.80371H15.5632L8.18427 10.7657Z"
				fill="url(#paint1_linear_1686_2837)"
			/>
			<defs>
				<linearGradient
					id="paint0_linear_1686_2837"
					x1="31.3458"
					y1="24.993"
					x2="32.9988"
					y2="15.1957"
					gradientUnits="userSpaceOnUse"
				>
					<stop />
					<stop offset="1" stopOpacity="0" />
				</linearGradient>
				<linearGradient
					id="paint1_linear_1686_2837"
					x1="12.5142"
					y1="5.00794"
					x2="10.8605"
					y2="14.8052"
					gradientUnits="userSpaceOnUse"
				>
					<stop />
					<stop offset="1" stopOpacity="0" />
				</linearGradient>
			</defs>
		</svg>
		{/* biome-ignore lint/a11y/noSvgWithoutTitle: <explanation> */}
		<svg
			width="169"
			height="24"
			viewBox="0 0 169 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M18.3656 1.23608V5.3592H11.6986V23.1011H6.8302V5.3592H0.197754V1.23608H18.3656Z"
				fill="white"
			/>
			<path
				d="M31.0655 7.48315H35.6161V23.1011H31.0655V21.2582C29.7012 22.7781 27.7854 23.5384 25.3159 23.5384C22.8463 23.5384 20.9471 22.742 19.2657 21.1492C17.5843 19.5557 16.7428 17.6039 16.7428 15.2921C16.7428 12.9804 17.5835 11.0285 19.2657 9.43502C20.9471 7.84227 22.9635 7.0459 25.3159 7.0459C27.7854 7.0459 29.7019 7.80621 31.0655 9.32608V7.48315ZM22.6698 18.4626C23.5864 19.2853 24.7509 19.6962 26.1618 19.6962C27.5728 19.6962 28.7425 19.2853 29.6719 18.4626C30.6005 17.6407 31.0655 16.5836 31.0655 15.2921C31.0655 14.0007 30.6012 12.9443 29.6719 12.1217C28.7425 11.2997 27.5735 10.888 26.1618 10.888C24.7501 10.888 23.5864 11.2997 22.6698 12.1217C21.7524 12.9443 21.2934 14.0014 21.2934 15.2921C21.2934 16.5829 21.7524 17.6407 22.6698 18.4626Z"
				fill="white"
			/>
			<path
				d="M44.2944 10.1698C44.7181 9.17059 45.4168 8.42079 46.3935 7.92118C47.3687 7.42157 48.4566 7.17139 49.6564 7.17139V11.6694C48.268 11.5237 47.0276 11.7738 45.9345 12.4192C44.8406 13.0653 44.2937 14.1374 44.2937 15.6363V23.1019H39.743V7.48393H44.2937V10.1698H44.2944Z"
				fill="white"
			/>
			<path
				d="M54.5594 5.6094C53.8066 5.6094 53.1537 5.36523 52.6015 4.87539C52.0486 4.38629 51.7728 3.80854 51.7728 3.14139C51.7728 2.47424 52.0493 1.89199 52.6015 1.39237C53.1545 0.89276 53.8066 0.642578 54.5594 0.642578C55.3122 0.642578 55.9996 0.89276 56.5526 1.39237C57.1048 1.89199 57.3813 2.47499 57.3813 3.14139C57.3813 3.80779 57.1048 4.38629 56.5526 4.87539C55.9996 5.36523 55.3355 5.6094 54.5594 5.6094ZM52.3017 23.1011V7.48314H56.8524V23.1011H52.3017Z"
				fill="white"
			/>
			<path
				d="M80.2763 4.36002C77.7827 4.19323 76.5363 5.07826 76.5363 7.0151V7.48391H80.2763V11.3568H76.5363V23.1019H71.9857V11.3568H66.7649V23.1019H62.2143V11.3568H59.6742V7.48391H62.2143V7.32764C62.2143 5.12033 62.9078 3.44344 64.2954 2.29846C65.6823 1.15348 67.7521 0.65387 70.5041 0.798871V4.67256C68.0106 4.50577 66.7649 5.39155 66.7649 7.32764V7.48391H71.9857V7.0151C71.9857 4.80779 72.6852 3.13165 74.0848 1.98592C75.4837 0.840943 77.5476 0.34058 80.2763 0.486331V4.36002Z"
				fill="white"
			/>
			<path
				d="M107.722 1.23608V5.3592H101.055V23.1011H96.1865V5.3592H89.554V1.23608H107.722Z"
				fill="white"
			/>
			<path
				d="M112.555 10.1698C112.979 9.17059 113.677 8.42079 114.654 7.92118C115.629 7.42157 116.717 7.17139 117.917 7.17139V11.6694C116.529 11.5237 115.288 11.7738 114.195 12.4192C113.101 13.0653 112.554 14.1374 112.554 15.6363V23.1019H108.004V7.48393H112.554V10.1698H112.555Z"
				fill="white"
			/>
			<path
				d="M122.82 5.6094C122.067 5.6094 121.414 5.36523 120.862 4.87539C120.309 4.38629 120.033 3.80854 120.033 3.14139C120.033 2.47424 120.31 1.89199 120.862 1.39237C121.415 0.89276 122.067 0.642578 122.82 0.642578C123.573 0.642578 124.26 0.89276 124.813 1.39237C125.365 1.89199 125.642 2.47499 125.642 3.14139C125.642 3.80779 125.365 4.38629 124.813 4.87539C124.26 5.36523 123.596 5.6094 122.82 5.6094ZM120.562 23.1011V7.48314H125.113V23.1011H120.562Z"
				fill="white"
			/>
			<path
				d="M139.542 7.04586C141.916 7.04586 143.945 7.84224 145.626 9.43499C147.308 11.0285 148.149 12.9804 148.149 15.2921C148.149 17.6038 147.308 19.5557 145.626 21.1492C143.945 22.742 141.916 23.5383 139.542 23.5383C137.167 23.5383 135.167 22.7788 133.826 21.2582V23.1011H129.276V1.23608H133.826V9.32605C135.167 7.80618 137.072 7.04586 139.542 7.04586ZM135.202 18.4626C136.119 19.2852 137.284 19.6962 138.695 19.6962C140.106 19.6962 141.276 19.2852 142.205 18.4626C143.134 17.6407 143.599 16.5836 143.599 15.2921C143.599 14.0006 143.134 12.9443 142.205 12.1216C141.276 11.2997 140.106 10.888 138.695 10.888C137.284 10.888 136.119 11.2997 135.202 12.1216C134.286 12.9443 133.826 14.0014 133.826 15.2921C133.826 16.5828 134.286 17.6407 135.202 18.4626Z"
				fill="white"
			/>
			<path
				d="M155.204 16.948C155.815 18.9059 157.474 19.8841 160.178 19.8841C161.919 19.8841 163.235 19.3634 164.129 18.3229L167.799 20.1966C166.058 22.425 163.495 23.5384 160.108 23.5384C157.192 23.5384 154.852 22.7578 153.088 21.1958C151.324 19.6339 150.442 17.6662 150.442 15.2921C150.442 12.918 151.312 10.9767 153.053 9.40422C154.794 7.83251 157.027 7.0459 159.755 7.0459C162.343 7.0459 164.476 7.83777 166.159 9.42C167.84 11.0022 168.681 12.9601 168.681 15.2921C168.681 15.8128 168.622 16.3642 168.504 16.9472H155.205L155.204 16.948ZM155.133 13.8249H164.129C163.87 12.7625 163.336 11.9714 162.525 11.4508C161.713 10.9301 160.79 10.6702 159.755 10.6702C158.532 10.6702 157.521 10.9466 156.722 11.4973C155.921 12.0495 155.392 12.8249 155.134 13.8249H155.133Z"
				fill="white"
			/>
		</svg>
	</>
);

export const ColourLogo = () => (
	<>
		{/* biome-ignore lint/a11y/noSvgWithoutTitle: <explanation> */}
		<svg
			width="56"
			height="38"
			viewBox="0 0 56 38"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M21.9572 26.7461H11.1797V37.3338H21.9572V26.7461Z"
				fill="#F65E46"
			/>
			<path
				d="M26.7127 0.666992L11.1794 26.7454V11.2547H0.949219V0.666992H26.7127Z"
				fill="#F65E46"
			/>
			<path
				d="M25.6205 37.3331V23.0455H17.7695L31.1005 0.666992V14.9556H38.9514L25.6205 37.3331Z"
				fill="#22082B"
			/>
			<path
				d="M45.5432 0.666992H34.7656V11.2547H45.5432V0.666992Z"
				fill="#F65E46"
			/>
			<path
				d="M55.7808 26.7466V37.3343H30.0117L36.3216 26.7466L45.545 11.2559V26.7466H55.7808Z"
				fill="#F65E46"
			/>
			<path
				opacity="0.48"
				d="M45.5438 24.2939V26.7455H36.3203L45.5438 24.2939Z"
				fill="url(#paint0_linear_13232_4218)"
			/>
			<path
				opacity="0.48"
				d="M11.1797 13.7083V11.2559H20.4032L11.1797 13.7083Z"
				fill="url(#paint1_linear_13232_4218)"
			/>
			<defs>
				<linearGradient
					id="paint0_linear_13232_4218"
					x1="40.1314"
					y1="31.491"
					x2="42.1976"
					y2="19.2446"
					gradientUnits="userSpaceOnUse"
				>
					<stop />
					<stop offset="1" stopOpacity="0" />
				</linearGradient>
				<linearGradient
					id="paint1_linear_13232_4218"
					x1="16.5921"
					y1="6.51121"
					x2="14.5249"
					y2="18.7576"
					gradientUnits="userSpaceOnUse"
				>
					<stop />
					<stop offset="1" stopOpacity="0" />
				</linearGradient>
			</defs>
		</svg>
		{/* biome-ignore lint/a11y/noSvgWithoutTitle: <explanation> */}
		<svg
			width="212"
			height="30"
			viewBox="0 0 212 30"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M23.1587 1.54492V6.69874H14.8251V28.8758H8.73966V6.69874H0.449219V1.54492H23.1587Z"
				fill="#22082B"
			/>
			<path
				d="M39.032 9.35418H44.7202V28.8763H39.032V26.5727C37.3266 28.4725 34.9319 29.4229 31.8451 29.4229C28.7582 29.4229 26.3842 28.4274 24.2824 26.4365C22.1807 24.4447 21.1289 22.0049 21.1289 19.1153C21.1289 16.2256 22.1798 13.7858 24.2824 11.794C26.3842 9.80307 28.9047 8.80762 31.8451 8.80762C34.9319 8.80762 37.3276 9.75799 39.032 11.6578V9.35418ZM28.5375 23.0783C29.6832 24.1066 31.1389 24.6203 32.9025 24.6203C34.6661 24.6203 36.1283 24.1066 37.29 23.0783C38.4507 22.0509 39.032 20.7296 39.032 19.1153C39.032 17.5009 38.4517 16.1805 37.29 15.1522C36.1283 14.1248 34.6671 13.6102 32.9025 13.6102C31.1379 13.6102 29.6832 14.1248 28.5375 15.1522C27.3909 16.1805 26.8171 17.5019 26.8171 19.1153C26.8171 20.7286 27.3909 22.0509 28.5375 23.0783Z"
				fill="#22082B"
			/>
			<path
				d="M55.568 12.7128C56.0977 11.4638 56.971 10.5266 58.1919 9.90207C59.4108 9.27757 60.7707 8.96484 62.2704 8.96484V14.5873C60.535 14.4051 58.9845 14.7178 57.6181 15.5245C56.2508 16.3321 55.5671 17.6722 55.5671 19.5458V28.8777H49.8789V9.35551H55.5671V12.7128H55.568Z"
				fill="#22082B"
			/>
			<path
				d="M68.3972 7.01117C67.4562 7.01117 66.6401 6.70596 65.9499 6.09367C65.2587 5.48231 64.9141 4.76013 64.9141 3.92621C64.9141 3.09228 65.2597 2.36447 65.9499 1.73996C66.6411 1.11546 67.4562 0.802734 68.3972 0.802734C69.3382 0.802734 70.1975 1.11546 70.8887 1.73996C71.5789 2.36447 71.9245 3.09322 71.9245 3.92621C71.9245 4.75919 71.5789 5.48231 70.8887 6.09367C70.1975 6.70596 69.3673 7.01117 68.3972 7.01117ZM65.5752 28.8755V9.35331H71.2634V28.8755H65.5752Z"
				fill="#22082B"
			/>
			<path
				d="M100.545 5.45001C97.4283 5.24153 95.8703 6.3478 95.8703 8.76882V9.35482H100.545V14.1959H95.8703V28.877H90.1821V14.1959H83.6563V28.877H77.9681V14.1959H74.793V9.35482H77.9681V9.15949C77.9681 6.40039 78.8349 4.3043 80.5694 2.8731C82.303 1.4419 84.8903 0.817396 88.3302 0.998643V5.84068C85.2133 5.6322 83.6563 6.73941 83.6563 9.15949V9.35482H90.1821V8.76882C90.1821 6.00972 91.0564 3.91457 92.806 2.48243C94.5546 1.05123 97.1343 0.425788 100.545 0.607975V5.45001Z"
				fill="#22082B"
			/>
			<path
				d="M134.85 1.54492V6.69874H126.516V28.8758H120.431V6.69874H112.141V1.54492H134.85Z"
				fill="#22082B"
			/>
			<path
				d="M140.892 12.7128C141.422 11.4638 142.295 10.5266 143.516 9.90207C144.735 9.27757 146.095 8.96484 147.595 8.96484V14.5873C145.859 14.4051 144.309 14.7178 142.942 15.5245C141.575 16.3321 140.891 17.6722 140.891 19.5458V28.8777H135.203V9.35551H140.891V12.7128H140.892Z"
				fill="#22082B"
			/>
			<path
				d="M153.721 7.01117C152.78 7.01117 151.964 6.70596 151.274 6.09367C150.583 5.48231 150.238 4.76013 150.238 3.92621C150.238 3.09228 150.584 2.36447 151.274 1.73996C151.965 1.11546 152.78 0.802734 153.721 0.802734C154.662 0.802734 155.522 1.11546 156.213 1.73996C156.903 2.36447 157.249 3.09322 157.249 3.92621C157.249 4.75919 156.903 5.48231 156.213 6.09367C155.522 6.70596 154.692 7.01117 153.721 7.01117ZM150.899 28.8755V9.35331H156.588V28.8755H150.899Z"
				fill="#22082B"
			/>
			<path
				d="M174.625 8.80704C177.593 8.80704 180.129 9.80249 182.231 11.7934C184.332 13.7852 185.384 16.225 185.384 19.1147C185.384 22.0043 184.332 24.4441 182.231 26.436C180.129 28.4269 177.593 29.4223 174.625 29.4223C171.656 29.4223 169.157 28.4729 167.481 26.5721V28.8758H161.793V1.54492H167.481V11.6572C169.157 9.75742 171.538 8.80704 174.625 8.80704ZM169.201 23.0777C170.347 24.106 171.803 24.6197 173.567 24.6197C175.33 24.6197 176.792 24.106 177.954 23.0777C179.115 22.0503 179.696 20.729 179.696 19.1147C179.696 17.5004 179.116 16.18 177.954 15.1516C176.792 14.1243 175.33 13.6096 173.567 13.6096C171.803 13.6096 170.347 14.1243 169.201 15.1516C168.055 16.18 167.481 17.5013 167.481 19.1147C167.481 20.7281 168.055 22.0503 169.201 23.0777Z"
				fill="#22082B"
			/>
			<path
				d="M194.206 21.1851C194.97 23.6324 197.043 24.8551 200.424 24.8551C202.6 24.8551 204.245 24.2043 205.363 22.9036L209.949 25.2458C207.773 28.0311 204.57 29.4229 200.336 29.4229C196.691 29.4229 193.766 28.4472 191.561 26.4948C189.356 24.5424 188.254 22.0828 188.254 19.1153C188.254 16.1477 189.341 13.721 191.517 11.7555C193.693 9.79086 196.485 8.80762 199.895 8.80762C203.129 8.80762 205.796 9.79744 207.899 11.7752C210.001 13.753 211.052 16.2003 211.052 19.1153C211.052 19.7661 210.978 20.4554 210.831 21.1841H194.207L194.206 21.1851ZM194.118 17.2812H205.363C205.039 15.9533 204.371 14.9644 203.357 14.3136C202.342 13.6628 201.188 13.3379 199.895 13.3379C198.366 13.3379 197.102 13.6835 196.103 14.3718C195.103 15.0621 194.442 16.0312 194.119 17.2812H194.118Z"
				fill="#22082B"
			/>
		</svg>
	</>
);

export const ColourSmallLogo = () => (
	<>
		{/* biome-ignore lint/a11y/noSvgWithoutTitle: <explanation> */}
		<svg
			width="33"
			height="22"
			viewBox="0 0 33 22"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M12.6048 15.6472H6.13818V21.9999H12.6048V15.6472Z"
				fill="#F65E46"
			/>
			<path
				d="M15.4583 0L6.13822 15.6473V6.35272H0V0H15.4583Z"
				fill="#F65E46"
			/>
			<path
				d="M14.8043 22V13.4273H10.0936L18.0923 0V8.57328H22.8029L14.8043 22Z"
				fill="#22082B"
			/>
			<path d="M26.7578 0H20.2912V6.35272H26.7578V0Z" fill="#F65E46" />
			<path
				d="M32.8983 15.6474V22.0001H17.4366L21.2226 15.6474L26.7568 6.35278V15.6474H32.8983Z"
				fill="#F65E46"
			/>
			<path
				opacity="0.48"
				d="M26.7568 14.1763V15.6472H21.2227L26.7568 14.1763Z"
				fill="url(#paint0_linear_1686_2101)"
			/>
			<path
				opacity="0.48"
				d="M6.13818 7.82427V6.35278H11.6724L6.13818 7.82427Z"
				fill="url(#paint1_linear_1686_2101)"
			/>
			<defs>
				<linearGradient
					id="paint0_linear_1686_2101"
					x1="23.5093"
					y1="18.4946"
					x2="24.7491"
					y2="11.1466"
					gradientUnits="userSpaceOnUse"
				>
					<stop />
					<stop offset="1" stopOpacity="0" />
				</linearGradient>
				<linearGradient
					id="paint1_linear_1686_2101"
					x1="9.38567"
					y1="3.50595"
					x2="8.14536"
					y2="10.8539"
					gradientUnits="userSpaceOnUse"
				>
					<stop />
					<stop offset="1" stopOpacity="0" />
				</linearGradient>
			</defs>
		</svg>
		{/* biome-ignore lint/a11y/noSvgWithoutTitle: <explanation> */}
		<svg
			width="128"
			height="18"
			viewBox="0 0 128 18"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M14.5242 0.927002V4.01934H9.52396V17.3258H5.87265V4.01934H0.898315V0.927002H14.5242Z"
				fill="#22082B"
			/>
			<path
				d="M24.0492 5.61236H27.4621V17.3258H24.0492V15.9436C23.0259 17.0835 21.5891 17.6538 19.7369 17.6538C17.8848 17.6538 16.4603 17.0565 15.1993 15.8619C13.9382 14.6668 13.3071 13.2029 13.3071 11.4691C13.3071 9.7353 13.9377 8.27139 15.1993 7.07627C16.4603 5.88171 17.9727 5.28442 19.7369 5.28442C21.5891 5.28442 23.0265 5.85466 24.0492 6.99456V5.61236ZM17.7524 13.847C18.4398 14.464 19.3132 14.7722 20.3714 14.7722C21.4296 14.7722 22.3069 14.464 23.0039 13.847C23.7004 13.2305 24.0492 12.4377 24.0492 11.4691C24.0492 10.5005 23.701 9.70825 23.0039 9.09125C22.3069 8.47481 21.4302 8.16602 20.3714 8.16602C19.3126 8.16602 18.4398 8.47481 17.7524 9.09125C17.0644 9.70825 16.7201 10.5011 16.7201 11.4691C16.7201 12.4371 17.0644 13.2305 17.7524 13.847Z"
				fill="#22082B"
			/>
			<path
				d="M33.9708 7.62724C34.2886 6.87782 34.8126 6.31547 35.5451 5.94076C36.2765 5.56605 37.0924 5.37842 37.9923 5.37842V8.75193C36.951 8.64262 36.0207 8.83025 35.2008 9.31428C34.3804 9.79886 33.9702 10.6029 33.9702 11.7271V17.3263H30.5573V5.61282H33.9702V7.62724H33.9708Z"
				fill="#22082B"
			/>
			<path
				d="M41.6695 4.20705C41.1049 4.20705 40.6153 4.02392 40.2011 3.65654C39.7864 3.28972 39.5796 2.85641 39.5796 2.35604C39.5796 1.85568 39.7869 1.41899 40.2011 1.04428C40.6158 0.66957 41.1049 0.481934 41.6695 0.481934C42.2341 0.481934 42.7497 0.66957 43.1644 1.04428C43.5786 1.41899 43.7859 1.85624 43.7859 2.35604C43.7859 2.85584 43.5786 3.28972 43.1644 3.65654C42.7497 4.02392 42.2516 4.20705 41.6695 4.20705ZM39.9763 17.3258V5.61235H43.3892V17.3258H39.9763Z"
				fill="#22082B"
			/>
			<path
				d="M60.9572 3.26995C59.087 3.14486 58.1522 3.80863 58.1522 5.26127V5.61287H60.9572V8.51758H58.1522V17.3263H54.7392V8.51758H50.8237V17.3263H47.4107V8.51758H45.5056V5.61287H47.4107V5.49567C47.4107 3.84019 47.9308 2.58252 48.9715 1.72378C50.0117 0.865051 51.5641 0.490342 53.6281 0.599092V3.50436C51.7579 3.37927 50.8237 4.0436 50.8237 5.49567V5.61287H54.7392V5.26127C54.7392 3.60578 55.2638 2.34868 56.3136 1.48938C57.3628 0.630646 58.9106 0.255374 60.9572 0.364687V3.26995Z"
				fill="#22082B"
			/>
			<path
				d="M81.5414 0.927002V4.01934H76.5412V17.3258H72.8899V4.01934H67.9155V0.927002H81.5414Z"
				fill="#22082B"
			/>
			<path
				d="M85.1663 7.62724C85.4841 6.87782 86.0081 6.31547 86.7406 5.94076C87.472 5.56605 88.2879 5.37842 89.1878 5.37842V8.75193C88.1465 8.64262 87.2162 8.83025 86.3963 9.31428C85.5759 9.79886 85.1657 10.6029 85.1657 11.7271V17.3263H81.7527V5.61282H85.1657V7.62724H85.1663Z"
				fill="#22082B"
			/>
			<path
				d="M92.865 4.20705C92.3004 4.20705 91.8108 4.02392 91.3966 3.65654C90.9819 3.28972 90.7751 2.85641 90.7751 2.35604C90.7751 1.85568 90.9824 1.41899 91.3966 1.04428C91.8113 0.66957 92.3004 0.481934 92.865 0.481934C93.4296 0.481934 93.9452 0.66957 94.3599 1.04428C94.774 1.41899 94.9814 1.85624 94.9814 2.35604C94.9814 2.85584 94.774 3.28972 94.3599 3.65654C93.9452 4.02392 93.4471 4.20705 92.865 4.20705ZM91.1718 17.3258V5.61235H94.5847V17.3258H91.1718Z"
				fill="#22082B"
			/>
			<path
				d="M105.406 5.28434C107.187 5.28434 108.709 5.88162 109.97 7.07618C111.231 8.27131 111.862 9.73521 111.862 11.469C111.862 13.2028 111.231 14.6667 109.97 15.8618C108.709 17.0564 107.187 17.6537 105.406 17.6537C103.625 17.6537 102.125 17.084 101.12 15.9436V17.3258H97.7069V0.927002H101.12V6.99448C102.125 5.85457 103.554 5.28434 105.406 5.28434ZM102.152 13.8469C102.84 14.4639 103.713 14.7721 104.771 14.7721C105.829 14.7721 106.707 14.4639 107.404 13.8469C108.1 13.2304 108.449 12.4376 108.449 11.469C108.449 10.5004 108.101 9.70816 107.404 9.09116C106.707 8.47472 105.829 8.16594 104.771 8.16594C103.713 8.16594 102.84 8.47472 102.152 9.09116C101.464 9.70816 101.12 10.501 101.12 11.469C101.12 12.4371 101.464 13.2304 102.152 13.8469Z"
				fill="#22082B"
			/>
			<path
				d="M117.153 12.711C117.612 14.1794 118.855 14.913 120.884 14.913C122.189 14.913 123.176 14.5226 123.847 13.7422L126.599 15.1475C125.293 16.8187 123.371 17.6538 120.831 17.6538C118.644 17.6538 116.889 17.0683 115.566 15.8969C114.243 14.7254 113.582 13.2497 113.582 11.4691C113.582 9.68853 114.234 8.23251 115.54 7.05317C116.845 5.87438 118.52 5.28442 120.566 5.28442C122.507 5.28442 124.107 5.87832 125.369 7.065C126.63 8.25167 127.26 9.72008 127.26 11.4691C127.26 11.8596 127.217 12.2732 127.128 12.7104H117.153L117.153 12.711ZM117.1 10.3686H123.847C123.653 9.57189 123.252 8.97855 122.643 8.58806C122.035 8.19758 121.342 8.00262 120.566 8.00262C119.649 8.00262 118.891 8.20998 118.291 8.623C117.691 9.03715 117.294 9.61866 117.1 10.3686H117.1Z"
				fill="#22082B"
			/>
		</svg>
	</>
);

export const MobileLogo = () => (
	<div className="sm:hidden flex gap-1.5 items-center">
		<ColourSmallLogo />
	</div>
);

export const DesktopLogo = () => (
	<div className="hidden sm:flex gap-1.5 items-center">
		<WhiteLogo />
	</div>
);

export const Logo = () => (
	<div className="contents">
		<MobileLogo />
		<DesktopLogo />
	</div>
);
